import * as React from "react";

function BookmarkIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={12} height={17} fill="none" {...props}>
      <path
        d="M10.5.35c.813 0 1.5.688 1.5 1.5v13.5c0 .782-.844 1.25-1.531.876L6 13.6l-4.5 2.625C.812 16.6 0 16.132 0 15.35V1.85A1.5 1.5 0 011.5.35h9zm0 14.126V2.038c0-.094-.094-.187-.219-.187H1.656c-.093 0-.156.093-.156.187v12.438L6 11.85l4.5 2.625z"
        fill="#2F3A49"
      />
    </svg>
  );
}

const MemoBookmarkIcon = React.memo(BookmarkIcon);
export default MemoBookmarkIcon;
